import classNames from 'classnames';
import React from 'react';

import './styles.scss';

export interface ConfirmationExitBoxProps {
  className: string;
  exitLocation: string;
  heading: JSX.Element | string;
  id: string;
  image?: string;
  subHeading: JSX.Element | string;
}
export const ConfirmationExitBox: React.FC<ConfirmationExitBoxProps> = ({
  className,
  children,
  exitLocation,
  heading,
  id,
  image,
  subHeading,
}) => {
  const graphic =
    typeof image === 'string' ? <img alt="" src={image} /> : image;

  return (
    <a
      className="confirmation-exit-box"
      data-testid="confirm-view-dashboard"
      href={exitLocation}
      id={id}
    >
      <div className={classNames('confirmation-exit-box-exit-box', className)}>
        <div className="confirmation-exit-box-exit-image">
          {children ?? graphic}
        </div>
        <div className="confirmation-exit-box-headings-container">
          <div className="college-branded-text confirmation-exit-box-header">
            {heading}
          </div>
          <div className="confirmation-exit-box-sub-header">{subHeading}</div>
        </div>
      </div>
    </a>
  );
};

export default ConfirmationExitBox;
